/* eslint-disable no-console */
import {DenialLetterOdontoParams} from 'domain/usecases/private/authorizations-odonto/get-denial-letter-odonto';
import {useCallback} from 'react';
import {useGetDenialLetterOdontoQuery} from '../queries/useGetDenialLetterOdontoQuery';

export const useDenialLetterOdontoHandler = (params: DenialLetterOdontoParams) => {
	const {
		data: denialLetterData,
		refetch: fetchDenialLetter,
		isFetching: isFetchingDenialLetter,
	} = useGetDenialLetterOdontoQuery(params);

	const triggerDownload = (blob: Blob) => {
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = `termo-de-indeferimento-odonto-${params.cdAutorizacao}.pdf`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	const downloadDenialLetter = useCallback(async () => {
		try {
			if (denialLetterData) {
				triggerDownload(denialLetterData);
				return;
			}

			const {data} = await fetchDenialLetter();
			if (!data) throw new Error('Arquivo não retornado.');
			triggerDownload(data);
		} catch (error) {
			console.error('Erro ao gerar carta de indeferimento:', error);
			throw new Error('Falha ao gerar a carta de indeferimento.');
		}
	}, [fetchDenialLetter, denialLetterData]);

	return {
		isFetchingDenialLetter,
		downloadDenialLetter,
	};
};
